var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Tree组件
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';

import { classPrefix } from '../../common/util';

import TreeNodes from './TreeNodes.js';

import './Tree.less';

/**
 * 参数说明
 * className               可选，自定义class
 * classPrefix             可选，自定义前缀
 * optionData              可选，数据
 * width                   可选自定义宽度，
 * uniqueKeyName           optionData中的唯一性key的名称，默认‘id’
 * checkable               可选，是否带有checkbox
 * defaultExpandAll        可选，默认展开所有节点
 * defaultExpandedKeys     可选，默认展开节点数组
 * defaultCheckedKeys      可选，默认节点选择数组
 * onCheck                 可选，点击checkbox的回调函数
 * onSelect                可选，点击文本选择的回调函数
 * titleCheckbox           可选，点击文本关联checkbox
 * inSelect                可选，是否文本区域撑满
 */

var Tree = function (_Component) {
    _inherits(Tree, _Component);

    function Tree(props) {
        _classCallCheck(this, Tree);

        var _this = _possibleConstructorReturn(this, (Tree.__proto__ || Object.getPrototypeOf(Tree)).call(this, props));

        _initialiseProps.call(_this);

        var checkboxArr = _this.iteratorCheckboxArr(props.optionData, props);
        checkboxArr = _this.formateCheckboxArr(checkboxArr);
        _this.state = { checkboxArr: checkboxArr };
        _this.oldSelectArr = null;
        _this.selectArr = props.defaultCheckedKeys;
        return _this;
    }

    _createClass(Tree, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (np.control) {
                this.initCheckboxArr(np);
            }
        }
    }, {
        key: 'initCheckboxArr',
        value: function initCheckboxArr(props) {
            var checkboxArr = this.iteratorCheckboxArr(props.optionData, props);
            checkboxArr = this.formateCheckboxArr(checkboxArr);
            this.setState({
                checkboxArr: checkboxArr
            });
        }

        // 将数据添加上checked状态

    }, {
        key: 'iteratorCheckboxArr',
        value: function iteratorCheckboxArr(data, props) {
            var _this2 = this;

            if (data === undefined || data.length === 0) {
                return;
            }
            var defaultCheckedKeys = props.defaultCheckedKeys,
                defaultDisabledKeys = props.defaultDisabledKeys,
                defaultSelectedKey = props.defaultSelectedKey,
                uniqueKeyName = props.uniqueKeyName;

            return data.map(function (rowData) {
                var newRowData = _.cloneDeep(rowData);
                newRowData.checked = defaultCheckedKeys.indexOf(rowData[uniqueKeyName]) !== -1;
                newRowData.disabled = defaultDisabledKeys.indexOf(rowData[uniqueKeyName]) !== -1;
                newRowData.selected = defaultSelectedKey === newRowData[uniqueKeyName];
                if (_.hasIn(newRowData, 'children')) {
                    newRowData.children = _this2.iteratorCheckboxArr(newRowData.children, props);
                }
                return newRowData;
            });
        }

        // 根据子数据checked状态，决定自身checked状态

    }, {
        key: 'formateCheckboxArr',
        value: function formateCheckboxArr(data) {
            var _this3 = this;

            if (data === undefined || data.length === 0) {
                return [];
            }
            return data.map(function (rowData) {
                var newRowData = _.cloneDeep(rowData);
                if (_.hasIn(newRowData, 'children')) {
                    newRowData.children = _this3.formateCheckboxArr(newRowData.children);
                    var count = 0;
                    newRowData.children.forEach(function (i) {
                        if (i.checked) {
                            count++;
                        }
                    });
                    switch (count) {
                        case 0:
                            // 取消选择
                            newRowData.checked = false;
                            break;
                        case newRowData.children.length:
                            // 全选
                            newRowData.checked = true;
                            break;
                        default:
                            // 部分选择
                            newRowData.checked = -1;
                            break;
                    }
                }
                return newRowData;
            });
        }

        // 参数：data数据，num迭代层次，position坐标位置，包含每一级数据的uniqueKeyName的值

    }, {
        key: 'clearAllSelected',
        value: function clearAllSelected(data) {
            var _this4 = this;

            if (!data) {
                return null;
            }
            return data.map(function (i) {
                var newI = _.cloneDeep(i);
                newI.selected = false;
                newI.children && (newI.children = _this4.clearAllSelected(newI.children));
                return newI;
            });
        }
    }, {
        key: 'formateOutputData',
        value: function formateOutputData(_ref) {
            var checkboxArr = _ref.checkboxArr;

            this.getSelectArr(checkboxArr, true);
            // 保持已选择数据顺序的前提下，在尾部添加新元素
            this.selectArr = _.union(_.intersection(this.oldSelectArr, this.selectArr), this.selectArr);
            this.onCheck(this.selectArr);
        }

        // 判断子数据是否全选（不计算diabled态）

    }, {
        key: 'isChildrenAllSelect',
        value: function isChildrenAllSelect(children) {
            for (var i = 0; i < children.length; i++) {
                var nowChild = children[i];
                if (!nowChild.checked && !nowChild.disabled) {
                    return false;
                }
                if (_.hasIn(nowChild, 'children') && !this.isChildrenAllSelect(nowChild.children)) {
                    return false;
                }
            }
            return true;
        }
    }, {
        key: 'onCheck',
        value: function onCheck(e) {
            var onCheck = this.props.onCheck;
            _.isFunction(onCheck) && onCheck(e);
        }

        // 将数据中选择项存入this.selectArr

    }, {
        key: 'getSelectArr',
        value: function getSelectArr(data, first) {
            var _this5 = this;

            if (first) {
                this.oldSelectArr = this.selectArr;
                this.selectArr = [];
            }
            data.map(function (i) {
                i.checked === true && _this5.selectArr.push(i[_this5.props.uniqueKeyName]);
                i.children && _this5.getSelectArr(i.children);
            });
        }
    }, {
        key: 'iteratorFindObj',
        value: function iteratorFindObj(data, position) {
            if (!position || position.length === 0) {
                return data;
            }

            var _position = _toArray(position),
                current = _position[0],
                other = _position.slice(1);

            for (var i = 0; i < data.length; i++) {
                if (data[i][this.props.uniqueKeyName] === current) {
                    if (other && other.length !== 0 && data[i].children) {
                        return this.iteratorFindObj(data[i].children, other);
                    }
                    return data[i];
                }
            }
        }
    }, {
        key: 'checkboxChangeChildren',
        value: function checkboxChangeChildren(data, bool) {
            var _this6 = this;

            return data.map(function (i) {
                var newI = _.cloneDeep(i);
                if (newI.disabled) {
                    return newI;
                }
                newI.checked = bool;
                if (_.hasIn(newI, 'children')) {
                    newI.children = _this6.checkboxChangeChildren(newI.children, bool);
                }
                return newI;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                className = _props.className,
                classPrefix = _props.classPrefix,
                width = _props.width,
                optionData = _props.optionData;

            var rootCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-tree-wrap', true), _defineProperty(_classnames, className, !!className), _classnames));
            var rootStyle = {
                width: width
            };
            var hasData = optionData.length !== 0;
            return React.createElement(
                'div',
                { className: rootCls, style: rootStyle },
                hasData ? this.iteratorRow(this.state.checkboxArr, 0) : React.createElement(
                    'div',
                    { className: 'no-data-div' },
                    '\u6682\u65E0\u6570\u636E'
                )
            );
        }
    }]);

    return Tree;
}(Component);

Tree.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    optionData: PropTypes.array,
    width: PropTypes.number,
    uniqueKeyName: PropTypes.string,
    checkable: PropTypes.bool,
    defaultExpandAll: PropTypes.bool,
    defaultExpandedKeys: PropTypes.array,
    defaultCheckedKeys: PropTypes.array,
    defaultDisabledKeys: PropTypes.array,
    defaultSelectedKey: PropTypes.string,
    onCheck: PropTypes.func,
    onSelect: PropTypes.func,
    control: PropTypes.bool,
    titleCheckbox: PropTypes.bool,
    inSelect: PropTypes.bool
};
Tree.defaultProps = {
    classPrefix: classPrefix,
    optionData: [],
    width: 151,
    uniqueKeyName: 'id',
    defaultExpandAll: false,
    defaultExpandedKeys: [],
    defaultDisabledKeys: [],
    defaultCheckedKeys: []
};

var _initialiseProps = function _initialiseProps() {
    var _this7 = this;

    this.iteratorRow = function (data, num) {
        var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        if (data === undefined || data.length === 0) {
            return;
        }
        var uniqueKeyName = _this7.props.uniqueKeyName;
        return data.map(function (rowData) {
            return React.createElement(TreeNodes, _extends({
                key: rowData[uniqueKeyName]
            }, _this7.props, {
                rowData: rowData,
                iteratorRow: _this7.iteratorRow,
                num: num,
                position: [].concat(_toConsumableArray(position), [rowData[uniqueKeyName]]),
                checkboxHandle: _this7.checkboxHandle,
                selectHandle: _this7.selectHandle
            }));
        });
    };

    this.selectHandle = function (_ref2) {
        var position = _ref2.position;

        if (_this7.props.titleCheckbox) {
            _this7.checkboxHandle({ position: position });
            _this7.onSelect({ position: position });
            return;
        }
        var newArr = _.cloneDeep(_this7.state.checkboxArr);
        newArr = _this7.clearAllSelected(newArr);
        var obj = _this7.iteratorFindObj(newArr, position);
        obj.selected = !obj.selected;
        _this7.setState({ checkboxArr: newArr }, function () {
            _this7.onSelect({ position: position });
        });
    };

    this.onSelect = function (_ref3) {
        var position = _ref3.position;

        var onSelect = _this7.props.onSelect;
        _.isFunction(onSelect) && onSelect({
            current: position[position.length - 1],
            position: position
        });
    };

    this.checkboxHandle = function (_ref4) {
        var position = _ref4.position;

        var newArr = _.cloneDeep(_this7.state.checkboxArr);
        var obj = _this7.iteratorFindObj(newArr, position);
        obj.checked = obj.checked !== true;
        if (_.hasIn(obj, 'children')) {
            // 保证含有disabled部分全选子节点，点击后可取消全选
            obj.checked = !_this7.isChildrenAllSelect(obj.children);
            obj.children = _this7.checkboxChangeChildren(obj.children, obj.checked);
        }
        var checkboxArr = _this7.formateCheckboxArr(newArr);
        if (_this7.props.control) {
            _this7.formateOutputData({ checkboxArr: checkboxArr });
            return;
        }
        _this7.setState({ checkboxArr: checkboxArr }, function () {
            _this7.formateOutputData({ checkboxArr: checkboxArr });
        });
    };
};

export default Tree;